import { render, staticRenderFns } from "./ClientUserAdd.vue?vue&type=template&id=928f4286&scoped=true"
import script from "./ClientUserAdd.vue?vue&type=script&lang=js"
export * from "./ClientUserAdd.vue?vue&type=script&lang=js"
import style0 from "./ClientUserAdd.vue?vue&type=style&index=0&id=928f4286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928f4286",
  null
  
)

export default component.exports